import React from "react";
import fp from "lodash/fp";
import { connect } from "react-redux";
import { Prompt } from "react-router";

import { URLS } from "globalConstants";

const defaultMessage = location => {
	return location.state?.submit || location.pathname.startsWith(URLS.login)
		? true
		: "You have unsaved changes, are you sure you want to leave?";
};

const CustomPrompt = ({
	isSessionExpired,
	when,
	message = defaultMessage,
	...props
}) => {
	const isCurrentUserLoggedIn = !fp.isEmpty(localStorage.getItem("user"));
	return (
		<Prompt
			when={isCurrentUserLoggedIn && when}
			message={message}
			{...props}
		/>
	);
};

const mapStateToProps = state => ({
	isSessionExpired: state.user.isSessionExpired,
});

const customPrompt = connect(mapStateToProps)(CustomPrompt);

export { customPrompt as CustomPrompt };
